import { useMemo } from 'react';
import PropTypes from 'prop-types';
import bbox from '@turf/bbox';
import { Typography } from '@mui/material';
import GoogleMap from '../../components/google/maps/Map';
import LocalDate from '../../components/LocalDate';
import { useGrowers } from '../../hooks/use-growers';

Map.propTypes = {
  aaid: PropTypes.string.isRequired,
  boundary: PropTypes.object.isRequired,
};

const historicalEnabledLayers = [
  'potassium-critical',
  'potassium-delta-critical',
  'potassium-removal',
  'potassium',
  'phosphorus',
  'phosphorus-critical',
  'phosphorus-delta-critical',
  'phosphorus-removal',
  'potential-productivity',
  'nitrogen-loss',
  'swi',
  'slope',
  'om',
  'cec',
  'buffer-ph',
  'ph',
  'boundary',
];

function layers(supportingLayers) {
  return supportingLayers
    .filter((layer) => historicalEnabledLayers.includes(layer.id))
    .map((layer) => ({ ...layer, buildLayerLabel }));
}

function buildLayerSubLabel(meta = {}) {
  const { createdAt, startsAt, endsAt } = meta;

  if (startsAt)
    return (
      <>
        <LocalDate value={startsAt} timeZone="UTC" />
        {' - '}
        {endsAt ? <LocalDate value={endsAt} timeZone="UTC" /> : 'Current'}
      </>
    );
  if (createdAt) return <LocalDate value={createdAt} />;
}

function buildLayerLabel(layer) {
  const subLabel = buildLayerSubLabel(layer?.meta);

  if (!subLabel) return layer.name;

  return (
    <>
      {layer.name}
      <Typography sx={{ fontSize: '.8rem !important' }}>{subLabel}</Typography>
    </>
  );
}

export function Map(props) {
  const {
    aaid = '00000000-0000-0000-0000-000000000000',
    boundary,
    boundaryId,
    endsAt,
    getControls,
  } = props;
  const { selectedId: growerId } = useGrowers();
  const bounds = useMemo(() => bbox(boundary), [boundary]);
  const filters = useMemo(
    () => ({ growerId: growerId || props.growerId, aaid, boundaryId, endsAt }),
    [growerId, aaid, boundaryId, endsAt, props.growerId],
  );

  return (
    <GoogleMap
      pkRemovalEnabled
      filters={filters}
      bounds={bounds}
      layers={layers}
      selectedFeatures={{ boundary: [aaid] }}
      getControls={getControls}
    />
  );
}
